<template>
  <div>
    <div class="clippy_notifications chat row">
      <div class="col-8">
        <ClippyToast
          v-for="(item, index) in items"
          :key="'clippy-'+index"
          :title="item.title"
          :message="item.message"
          :time="item.time"
        />
      </div>
      <div class="col-4" />
    </div>
    <div class="clippy_notifications row">
      <div clsas="col-8" />
      <div class="col-4">
        <img
          src="@/assets/img/ana.png"
          alt="assistant icon"
          height="120"
          class="ana"
          :style="displayAna"
          @click="hideAna"
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name: 'ClippyNotifications',
    computed: {
        items() {
            return this.$store.state.clippyNotifications.items;
        },
        displayAna() {
            if (this.items.length === 0) {
                return 'display: none;';
            }
            return '';
        },
    },
    methods: {
        hideAna() {
            this.$store.dispatch('clippyNotifications/clearAll');
        },
    },
};
</script>
<style lang="scss">
.ana {
  border-radius: 50%;
}
.clippy_icon{
  position: fixed;
  bottom:0;
}
.clippy_notifications{
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom: 50px;
    margin-right: 20px !important;
    z-index: 9999999;
}
.chat{
  margin-bottom: 80px;
}
</style>
